<po-page-default p-title="Conciliação Contas de Fornecedores" [p-breadcrumb]="breadcrumb"
  p-subtitle="Concilie contas de fornecedores com base no histórico das contas do Domínio.">

  <div class="page-summary">
    <div class="page-summary-icon">
      <i class="an an-scales"></i>
    </div>
    <div class="page-summary-text">
      <p class="po-font-subtitle po-mb-0">Conciliação de Contas de Fornecedores</p>
      <p class="page-summary-hint">
        Esta rotina analisa o <b>histórico das contas</b> (provisões e pagamentos) e gera uma planilha
        de conciliação. O resultado é enviado por e-mail ao usuário autenticado.
      </p>
    </div>
  </div>

  <div class="warning-box">
    <i class="an an-warning"></i>
    <div>
      <p class="warning-title">Atenção — revise a planilha de conciliação</p>
      <p class="warning-text">
        A conciliação é feita automaticamente com base no histórico das contas e <b>pode conter erros</b>
        (matches por valor, nota ou parcelamento). Sempre confira o Excel recebido antes de usar os dados
        na contabilidade.
      </p>
    </div>
  </div>

  <po-divider></po-divider>

  <div class="pf-section po-mt-3">
    <div class="pf-section-header">
      <i class="an an-info"></i>
      <span>Como funciona</span>
    </div>
    <div class="pf-section-body">
      <div class="pf-rules">
        <div class="pf-rule">
          <i class="an an-check-circle"></i>
          <span>Envie a planilha no formato <b>.xlsx</b> (Excel 2007+). Se o Domínio exportar <b>.xls</b> ou HTML, abra no Excel e salve como .xlsx.</span>
        </div>
        <div class="pf-rule">
          <i class="an an-check-circle"></i>
          <span>O sistema concilia provisões e pagamentos com base no histórico (NF, valor e parcelamentos).</span>
        </div>
        <div class="pf-rule">
          <i class="an an-check-circle"></i>
          <span>Após o processamento, o Excel consolidado é enviado para o e-mail do seu usuário.</span>
        </div>
        <div class="pf-rule">
          <i class="an an-warning-circle"></i>
          <span>Revise os status e motivos da planilha gerada antes de finalizar a conciliação contábil.</span>
        </div>
      </div>
    </div>
  </div>

  <div class="pf-section po-mt-3">
    <div class="pf-section-header">
      <i class="an an-upload-simple"></i>
      <span>Envio da planilha</span>
    </div>
    <div class="pf-section-body">
      <div class="po-row">
        <po-input class="po-lg-3" name="codiEmp" p-label="Cód. Empresa (Domínio)"
          p-placeholder="Opcional" [(ngModel)]="codiEmp"
          p-help="Código da empresa no Domínio, se necessário para o processamento.">
        </po-input>
        <po-input class="po-lg-4" name="contaFornecedores" p-label="Conta de Fornecedores"
          p-placeholder="Opcional" [(ngModel)]="contaFornecedores"
          p-help="Conta contábil de fornecedores usada na conciliação.">
        </po-input>
      </div>

      <po-upload #upload class="po-mt-2" [p-restrictions]="restrictions" p-size="medium"
        [p-drag-drop]="true" [p-multiple]="false" [p-drag-drop-height]="150"
        [p-url]="urlPlaceholder" [p-hide-send-button]="true">
      </po-upload>

      <div class="pf-action-row po-mt-3">
        <po-button p-kind="primary" p-icon="an an-paper-plane-tilt"
          p-label="Gerar Conciliação" [p-disabled]="loading" [p-loading]="loading"
          (p-click)="enviarConciliacao()">
        </po-button>
      </div>
    </div>
  </div>

</po-page-default>
